<script lang="ts">
  import DemoButton from "./DemoButton.svelte";
  import LoginButton from "./LoginButton.svelte";

  let { testId }: { testId: string } = $props();
</script>

<div
  class="flex w-full max-w-xs flex-col-reverse gap-3 sm:w-auto sm:max-w-none sm:flex-row sm:justify-center"
>
  <DemoButton testId="{testId}-demo" />
  <LoginButton testId="{testId}-login" />
</div>
